import { useEffect, useState } from 'react'

export const useIsPageVisible = () => {
  const [isVisible, setIsVisible] = useState<boolean>(!document?.hidden)
  const visibilityChange = 'visibilitychange'
  const onVisibilityChange = () => setIsVisible(!document['hidden'])

  useEffect(() => {
    document.addEventListener(visibilityChange, onVisibilityChange, false)
    return () => {
      document.removeEventListener(visibilityChange, onVisibilityChange)
    }
  })

  return isVisible
}
